// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class Component {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, properties, propertyValues) {
        this.idInVersion = model.id;
        this.id = model.persistentId;
        this.brandId = model.brandId;
        this.name = model.meta.name;
        this.description = model.meta.description;
        this.properties = properties;
        this.propertyValues = {};
        propertyValues.forEach((value) => {
            if (value.targetElementId === this.id) {
                // Property value refers to this element
                properties.forEach((property) => {
                    if (property.id === value.definitionId) {
                        // Property value refers to the correct property, we get codeName from it and add it to quick-access
                        this.propertyValues[property.codeName] = value.value;
                    }
                });
            }
        });
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
    }
    toWriteObject() {
        var _a;
        return {
            id: this.idInVersion,
            persistentId: this.id,
            brandId: this.brandId,
            meta: {
                name: this.name,
                description: (_a = this.description) !== null && _a !== void 0 ? _a : "",
            },
        };
    }
    toWriteUpdateObject() {
        const model = this.toWriteObject();
        // @ts-expect-error TS(2790): The operand of a 'delete' operator must be optiona... Remove this comment to see the full error message
        delete model.brandId;
        return model;
    }
}
